import SingleOfferTemplate from "../../../component/template/SingleOfferTemplate";
import Button from "../../../component/visible/Button";
import {onScreenClick} from "../../../../common/report";
import Message from "../../../Message";

export default class EndcardBottom extends SingleOfferTemplate {
    constructor(...props) {
        super(...props)
        this.name = 'EndcardBottom';
        this.initCtaButton();
    }

    adShowed(data) {
        super.adShowed()
    }

    initComponents() {
        super.initComponents()
    }

    bindPageEvent() {
        super.bindPageEvent()
    }

    initCtaButton(){
        this.cta = new Button({
            type: "cta",
            long: "5",
            size: "4",
            text: this.campaign.ctatext,
            background: "#689f38",
            onClick: (event) => {
                console.log("下载按钮点击")
                onScreenClick.call(
                    this,
                    event,
                    {
                        autoClick: false,
                        template: 'ecBottom',
                        ctabanner: false,
                        campaign: this.campaign,
                        webviewWidth : window.screen.width,
                        webviewHeight: window.screen.height,
                    }
                )
                Message.emitMessageToSuperView('onInstallBtnClick', this.campaign)
            }
        })
        this.cta.appendTo(document.querySelector('.install-box'));
    }

    /**
     * 绑定native组件各个事件
     */
    bindNativeEvent() {
    }

    initSlots() {
        super.initSlots()
    }

    /**
     * 销毁组件
     */
    destory() {
        super.destory()
        this.cta && this.cta.destory()
    }
}